import { routeBuilder, TOOLS_ROUTE, ToolTabsTitles } from '../constants';

export enum TOOLS_ROUTES {
  BulkInvite = 'bulk-invite-users',
  MergeCompanies = 'merge-companies',
  DeviceLimitsWhiteList = 'device-limits-white-list',
  PasswordUpdates = 'password-updates',
  Underwriting = 'underwriting',
  ApplicationViewer = 'application-viewer',
  SubscriptionManagement = 'subscription-management',
  PTCompanyReset = 'pt-company-reset',
}

export const toolsRoute = routeBuilder<TOOLS_ROUTES>(TOOLS_ROUTE);

export const subNavList = [
  {
    title: ToolTabsTitles.MassInvite,
    path: toolsRoute`${TOOLS_ROUTES.BulkInvite}`,
  },
  {
    title: ToolTabsTitles.MergeCompanies,
    path: toolsRoute`${TOOLS_ROUTES.MergeCompanies}`,
  },
  {
    title: ToolTabsTitles.DeviceLimitsWhiteList,
    path: toolsRoute`${TOOLS_ROUTES.DeviceLimitsWhiteList}`,
  },
  {
    title: ToolTabsTitles.PasswordUpdates,
    path: toolsRoute`${TOOLS_ROUTES.PasswordUpdates}`,
  },
  {
    title: ToolTabsTitles.Underwriting,
    path: toolsRoute`${TOOLS_ROUTES.Underwriting}`,
  },
  {
    title: ToolTabsTitles.ApplicationViewer,
    path: toolsRoute`${TOOLS_ROUTES.ApplicationViewer}`,
  },
  {
    title: ToolTabsTitles.SubscriptionManagement,
    path: toolsRoute`${TOOLS_ROUTES.SubscriptionManagement}`,
  },
  {
    title: ToolTabsTitles.PTCompanyReset,
    path: toolsRoute`${TOOLS_ROUTES.PTCompanyReset}`,
  },
];
